import React from 'react';
import '../styles/Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">
        <div className="logo-section">
          <img 
            src="/images/logos/logo.png" 
            alt="VibeCode Logo" 
            className="logo"
            onError={(e) => {
              // Fallback if logo doesn't exist
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
          <div className="logo-fallback" style={{ display: 'none' }}>
            <h1 className="logo-text">VibeCode</h1>
          </div>
        </div>
        
        <div className="vision-section">
          <p className="vision-statement">
          We help those in healthcare ask the right questions at the right time and act on the right answers.
          </p>
        </div>
      </div>
    </header>
  );
};

export default Header; 